import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const PriceCtx = createContext(null);
const INTERVAL = 1000;

export const PriceProvider = ({ children }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true, busy = false;
    const load = () => {
      if (busy || document.hidden) return;
      busy = true;
      api.get("/price").then((r) => alive && setData({ ...r.data, at: Date.now() })).catch(() => {}).finally(() => { busy = false; });
    };
    load();
    const id = setInterval(load, INTERVAL);
    return () => { alive = false; clearInterval(id); };
  }, []);
  return <PriceCtx.Provider value={data}>{children}</PriceCtx.Provider>;
};

export const usePrice = () => useContext(PriceCtx);
